import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ClipLoader from "react-spinners/ClipLoader";

function Complete() {
  const MODE = 'DEV';
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [translationId, setTranslationId] = useState(queryParams.get('translation_id'));


  const url = "/?translation_id="+translationId

  return (
      <div className="complete-wrap">
        <ul>
          <li>
            <div className='icon'>
              <div>
                <svg viewBox="0 0 24 24" fill='#007bff'>
                  <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H15v-8h5V8l-6-6zm-1 7V3.5L18.5 9H13zm4 12.66V16h5.66v2h-2.24l2.95 2.95-1.41 1.41L19 19.41v2.24h-2z"></path>
                </svg>
              </div>
            </div>
            <div className='desc'>
              <div>{url}</div>
            </div>
            <div className='button'>
              <button className="step1-button" onClick={()=>{
                window.open(url)
              }} disabled={false}>
                GO EDITOR
              </button>
            </div>
          </li>
          <li style={{display:  'none' }}>
            <div className='icon'>
              <div>
                <svg viewBox="0 0 24 24" fill='#007bff'>
                  <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H15v-8h5V8l-6-6zm-1 7V3.5L18.5 9H13zm4 12.66V16h5.66v2h-2.24l2.95 2.95-1.41 1.41L19 19.41v2.24h-2z"></path>
                </svg>
              </div>
            </div>
            <div className='desc'>
              <div>https://www.google.com/search?q=mui+list&newwindow=1&sca_esv=566884281&sxsrf=AM9HkKn_l5xF0qEbmeA89MfgNveL3TAhHw%3A1695201959517&ei=p7oKZb-YH8zY-QbCsZXwCg&ved=0ahUKEwj_h_q077iBAxVMbN4KHcJYBa4Q4dUDCBA&uact=5&oq=mui+list&gs_lp=Egxnd3Mtd2l6LXNlcnAiCG11aS</div>
            </div>
            <div className='button'>
              <button className="reset-button" onClick={()=>{}} disabled={false}>
                <ClipLoader color="##fff" />
              </button>
            </div>
          </li>
        </ul>
        <div className='footer-button'>
          <button className="step1-button" onClick={()=>{
            window.location.href="/upload"
          }} disabled={false}>
            GO HOME
          </button>
        </div>
      </div>
  );
}

export default Complete;
